import { AxiosProgressEvent } from 'axios';
import { useEffect, useState } from 'react';

import { appLoadWasm } from '../appLoad';

export const useAppAuthLoad = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    (async () => {
      await appLoadWasm((event: AxiosProgressEvent) => {
        if (event.loaded && event.total) {
          const progress = event.loaded / event.total;
          const percentage_ = Math.round(progress * 100);
          setPercentage(percentage_);
        }
      });
      setPercentage(100);
      setIsLoaded(true);
    })();
  }, []);

  return { isLoaded, percentage };
};
